import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action, get, set } from "@ember/object"
import { inject as service } from "@ember/service"
import { handleError } from "cc-frontend/error-handling"
import editLessonTitleAction from "cc-frontend/lib/actions/lesson/LESSON_EDIT_TITLE"
import { LESSON_TITLE_INTERMEDIATE_UPDATE } from "cc-frontend/lib/actions/lesson/LESSON_TITLE_INTERMEDIATE_UPDATE"
import { task, timeout } from "ember-concurrency"
import styles from "./unit.module.css"

@tagName("")
export default class TimelineUnit extends Component {
  styles = styles
  @service("ember-store") store
  @service dispatcher
  @service session
  @service appState

  @service modalManager

  @service dialog

  @service lessonEditor

  intermediateUpdate = task({ keepLatest: true }, async ({ cardStackId, value }) => {
    get(this, "dispatcher").dispatchAction(LESSON_TITLE_INTERMEDIATE_UPDATE, {
      cardStackId: cardStackId,
      value: value,
    })
    await timeout(750)
  })

  @action
  onTitleEdited(value) {
    this.intermediateUpdate.perform({
      cardStackId: get(this, "unitInfo.id"),
      value: value,
    })
  }

  @action
  onFinishedEditingTitle(value, originalValue) {
    this.intermediateUpdate.cancelAll()
    get(this, "dispatcher").dispatchPreparedAction(
      editLessonTitleAction({
        planbookId: get(this, "planbook.id"),
        cardStackId: get(this, "unitInfo.id"),
        value: value,
        originalValue: originalValue,
      })
    )
  }

  @action
  showUnitInSidebar() {
    if (this.useModalManager) {
      const modalName = "planner/course/timeline/sidebar"
      if (get(this, `modalManager.openedModals.${modalName}.isVisible`)) {
        this.modalManager.closeModalOutsideManager()
      }
      this.modalManager.openModal(modalName, {
        cardStackId: this.unitInfo.id,
        courseId: this.course.id,
        planbookId: this.planbook.id,
        isUnit: true,
        startDate: this.unitInfo.startDate,
        endDate: this.unitInfo.endDate,
      })
    } else {
      get(this, "dispatcher").dispatch("SIDEBAR_SET_UNIT_ID", {
        sessionId: get(this, "appState.id"),
        unitInfo: get(this, "unitInfo"),
        cardStackId: get(this, "unitInfo.id"),
        courseId: get(this, "course.id"),
        componentId: "lesson-sidebar",
      })
      get(this, "dispatcher").dispatch("SIDEBAR_OPEN", {
        sessionId: get(this, "appState.id"),
        componentId: "lesson-sidebar",
      })
    }
    this.toggleMenu()
  }

  @action toggleMenu(event) {
    if (this.unitInfo.isMoving === true) return
    set(this.unitInfo, "contextMenuIsOpen", !this.unitInfo.contextMenuIsOpen)
    if (event) event.preventDefault()
  }

  @action eraseUnit() {
    this.toggleMenu()
    this.dialog
      .blank("dialogs/confirm-delete-unit", {
        className: "dialog--create-annotation",
      })
      .then((shouldDeleteLessons) => {
        this.lessonEditor.eraseUnit(
          this.unitInfo.id,
          this.course,
          this.planbook,
          this.rotationCalendar,
          shouldDeleteLessons
        )
      })
      .catch((error) => {
        if (error instanceof Error) handleError(error)
      })
  }
}
